<template>
  <div>
    <div v-if="isOverlayVisible" class="d-flex justify-space-around" id="overlayHeader">
      <div class="align-self-center mr-5">
        <vs-text type="paragraph" class="font-weight-bold"
          >This feature is not available with your current plan. You can unlock this feature with
          IronSight Pro.
        </vs-text>
      </div>
      <div class="align-self-center">
        <vs-button label="Learn More" @click="onClick" />
      </div>
    </div>
    <div :style="styleObject" ref="slotContainer">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'

const props = defineProps<{
  isOverlayVisible: boolean
  learnMoreUrl: string
}>()

const slotContainer = ref<HTMLElement | null>(null)

const styleObject = computed(() => ({
  opacity: props.isOverlayVisible ? 0.25 : 1,
  pointerEvents: props.isOverlayVisible ? 'none' : 'auto',
}))

const onClick = () => {
  window.open(props.learnMoreUrl)
}
</script>

<style scoped>
#overlayHeader {
  position: sticky;
  top: 0;
  z-index: var(--elevation-sticky-bar);
  background-color: white;
  padding-bottom: var(--space-small);
  border-bottom: 1px solid #ddd;
}
</style>
